import './footer.css';
import grSe from '../../assets/SE-Logo.webp';

const Footer = ({ currentPage, onShowImpressum, onShowDatenschutz }) => {
  return (
    <footer className="footer">
      <div className="footerContainer">
        <p>© 2025 Alle Rechte vorbehalten</p>
        <div className="footerLink">
          {/* Only show Impressum link if we're not on the Impressum page */}
          {currentPage !== 'impressum' && (
            <>
              <p 
                onClick={onShowImpressum} 
                style={{cursor: 'pointer'}}
              >
                Impressum
              </p>
              <span>|</span>
            </>
          )}
          
          {/* Only show Datenschutz link if we're not on the Datenschutz page */}
          {currentPage !== 'datenschutz' && (
            <p 
              onClick={onShowDatenschutz} 
              style={{cursor: 'pointer'}}
            >
              Datenschutz
            </p>
          )}
        </div>
        <a href='https://guerra-und-ramos-se.de' className='created'>
          Erstellt bei <img src={grSe} alt="" />
        </a>                    
      </div>
    </footer>
  );
}

export default Footer;